const INTERPOLATION_REGEX = /\{\{(\w+)\}\}/g;

export const SUPPORTED_LANGUAGES = ['en', 'mr'];
export const DEFAULT_LANGUAGE = 'en';
export const FALLBACK_LANGUAGE = 'en';

/**
 * Deep-merge source into target (mutates target).
 */
export function deepMerge(target, source) {
  if (!source || typeof source !== 'object') return target;
  Object.keys(source).forEach((key) => {
    const value = source[key];
    if (
      value &&
      typeof value === 'object' &&
      !Array.isArray(value) &&
      target[key] &&
      typeof target[key] === 'object' &&
      !Array.isArray(target[key])
    ) {
      deepMerge(target[key], value);
    } else {
      target[key] = value;
    }
  });
  return target;
}

export function getNestedValue(obj, keys) {
  let value = obj;
  for (const key of keys) {
    if (value == null || typeof value !== 'object' || !(key in value)) {
      return undefined;
    }
    value = value[key];
  }
  return value;
}

export function interpolate(template, params = {}) {
  if (typeof template !== 'string') return template;
  return template.replace(INTERPOLATION_REGEX, (_, name) => {
    if (Object.prototype.hasOwnProperty.call(params, name)) {
      return String(params[name]);
    }
    return `{{${name}}}`;
  });
}

/**
 * Resolve a dot-notation key with fallback: current lang → English → key string.
 */
export function resolveTranslation(translations, language, key, params) {
  const keys = key.split('.');
  let value = getNestedValue(translations[language], keys);

  if (value === undefined && language !== FALLBACK_LANGUAGE) {
    value = getNestedValue(translations[FALLBACK_LANGUAGE], keys);
  }

  if (typeof value === 'string') {
    return interpolate(value, params);
  }

  if (process.env.NODE_ENV === 'development') {
    console.warn(`[i18n] Missing translation key: "${key}" (${language})`);
  }

  return key;
}

export function hasTranslation(translations, language, key) {
  const keys = key.split('.');
  return (
    getNestedValue(translations[language], keys) !== undefined ||
    getNestedValue(translations[FALLBACK_LANGUAGE], keys) !== undefined
  );
}
